const profileStyles = (theme) => ({
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "inherit",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "inherit",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "360px",
    padding: "32px",
    borderRadius: "20px",
    background: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.05)",
    backdropFilter: "blur(10px)",
    border: theme.palette.mode === "dark" ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(0, 0, 0, 0.1)",
  },
});

export default profileStyles;
